import { render } from "./PodAffinity.vue?vue&type=template&id=72a3a964"
import script from "./PodAffinity.vue?vue&type=script&lang=js"
export * from "./PodAffinity.vue?vue&type=script&lang=js"

import "./PodAffinity.vue?vue&type=style&index=0&id=72a3a964&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__